$(document).find('.js_blogs-small').each((i,el) => {
    let slides = +$(el).attr('data-count')
    let buttonNext = $(el).closest('.js_blogs__container').find('.js_blogs__btn-next')
    let buttonPrev = $(el).closest('.js_blogs__container').find('.js_blogs__btn-prev')
    let pagination = $(el).closest('.js_blogs__container').find('.js_global-slider__pagination')
    new Swiper (el, {
        autoHeight: false,
        loop: true,
        slidesPerView: 1,
        spaceBetween: 20,
        breakpoints: {
            568: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: 4,
            },
            1536: {
                slidesPerView: slides,
            }
        },
        navigation: {
            nextEl: buttonNext[0],
            prevEl: buttonPrev[0],
        },
        pagination: {
            el: pagination[0],
            clickable: true,
            bulletClass: 'global-slider__pagi-item',
            bulletActiveClass: 'global-slider__pagi-item_active'
        },
        modules: [SwiperModes.Navigation, SwiperModes.Pagination],
        centerInsufficientSlides: true,
        on: {
            init: function() {
                sliderVertical()
            }
        }
    })
})